/** Property keys that are never editable in the feature/collection properties editor. */
export const LOCKED_PROPERTY_KEYS: string[] = ["id"];

/** Property key prefixes that are never editable in the feature/collection properties editor. */
export const LOCKED_PROPERTY_PREFIXES: string[] = ["_pipeline_"];

/**
 * Property keys locked specifically for FeatureCollection-level properties.
 * These are generated by FileReaderService.prepareGeoJson() on import and must not be edited.
 */
export const LOCKED_COLLECTION_PROPERTY_KEYS: string[] = [
  "epsg",
  "id",
  "name",
  "bbox",
  "fileType",
  "customOverlayProperties",
];

/** Returns true if the given property key must be rendered read-only. */
export function isLockedPropertyKey(key: string, extraLockedKeys: string[] = LOCKED_PROPERTY_KEYS): boolean {
  return extraLockedKeys.includes(key) || LOCKED_PROPERTY_PREFIXES.some((prefix) => key.startsWith(prefix));
}
